import { REMOVE_SUGGESTION_ITEM, SET_SUGGESTIONS, SET_SUGGESTIONS_LOADING } from '@Actions/suggestionsActions';
export const defaultState = {
    count: 0,
    items: [],
    loading: false
};
export function suggestionsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_SUGGESTIONS: {
            return Object.assign(Object.assign({}, state), { count: action.payload.length, items: action.payload });
        }
        case SET_SUGGESTIONS_LOADING: {
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        }
        case REMOVE_SUGGESTION_ITEM: {
            return Object.assign(Object.assign({}, state), { count: state.count - 1, items: state.items.filter((suggestion) => suggestion.card_transaction_id !== action.payload.card_transaction_id) });
        }
        default:
            return state;
    }
}
